import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getDayOptions, getMonthOptions, getYearOptionsPlus, getYearOptions } from '../../../services/dateServices';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';
const FETCH_URL = "api/educations/teachershipadmin"
class GastCollege extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            errors: {}
        }
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        const deita = event.target.elements;
        for (var i = 0; i < deita.length; i++) {
            const e = deita[i] // Form element
            const name = e.name
            const value = e.value

            if (name && value)
                formData.append(name, value)
        }
        const file = this.fileInput.files[0]
        formData.append('MemberId', this.props.id)
        formData.append('file', file === undefined ? null : file)
        formData.append('type', 'gastcollege')

        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {

                alert('Docentschap saved')
                window.location.href = '/admin/leden/lid/kennis/' + this.props.id
            })
    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="GastCollegeNaamInstelling">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam Instelling
                    </Col>
                    <Col sm={6}>
                        <FormControl name="institution" type="text" required />
                        {Api.showError(errors, "nameOfInstitution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="GastCollegeNaamOpleiding">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam Opleiding
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" required />
                        {Api.showError(errors, "nameOfEducation")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="GastCollegeNiveau">
                    <Col componentClass={ControlLabel} sm={4}>
                        Niveau
                    </Col>
                    <Col sm={6}>
                        <FormControl name="level" componentClass="select" placeholder="">
                            <option value="">selecteer</option>
                            <option value="MBO/HBO">MBO/HBO</option>
                            <option value="Universitair">Universitair</option>
                        </FormControl>
                        {Api.showError(errors, "level")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="GastCollegePlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        <FormControl name="city" type="text" required />
                        {Api.showError(errors, "location")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="formHorizontalEmail" className="alignMultiSelect">
                    <Col componentClass={ControlLabel} sm={5}>
                        Datum gastcollege
                                </Col>
                    <Col sm={7}>
                        <FormControl componentClass="select" placeholder="" name="day" value={this.state.day} required>
                            <option value="0">-- dag --</option>
                            {getDayOptions}
                        </FormControl>
                        <FormControl componentClass="select" placeholder="" name="month" value={this.state.month} required>
                            <option value="0">-- maand --</option>
                            {getMonthOptions}
                        </FormControl>
                        <FormControl componentClass="select" placeholder="" name="year" value={this.state.year} required>
                            <option value="0">-- jaar --</option>
                            {getYearOptionsPlus()}
                        </FormControl>
                        {Api.showError(this.state.errors, "day")}
                        {Api.showError(this.state.errors, "month")}
                        {Api.showError(this.state.errors, "year")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="GastCollegeVoordracht">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam voordracht
                    </Col>
                    <Col sm={6}>
                        <FormControl name="description" type="text" required />
                        {Api.showError(errors, "activities")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="GastCollegeUpload">
                    <Col componentClass={ControlLabel} sm={4}>
                        Upload
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default GastCollege;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/GastCollege.js